import { Tag } from "antd";
import K from "utilities/constants";
import { getSubStatusColorKey } from "utilities/generalUtility";
import styles from "./statusTag.module.scss";

export const StatusTag = ({ status, style, parentStatus }) => {
  const colorKey = parentStatus
    ? getSubStatusColorKey(parentStatus, status)
    : status;
  const color = K.StatusTagColors[colorKey];
  return (
    <Tag
      className={`tagTextColor ${styles.statusTag}`}
      color={color}
      style={{ margin: 0, ...style }}
    >
      {status}
    </Tag>
  );
};
